import { actionTypeKeys } from "../actions/actionTypeKeys";
import { DeepLink, DeepLinkStatus } from "../types/deepLink";
import { AnyAction, Dispatch } from "redux";
import MarketingLinksApi from "../api/marketingLinkApi";

export default class MarketingLinkActions {
  static setDeepLink = (link: DeepLink): AnyAction => {
    return {
      type: actionTypeKeys.SET_DEEP_LINK,
      payload: link
    };
  };

  static setDeepLinkStatus = (status: DeepLinkStatus): AnyAction => {
    return {
      type: actionTypeKeys.UPDATE_DEEP_LINK_STATUS,
      payload: status
    };
  };

  static setAppointmentAudit = (id: string): AnyAction => {
    return {
      type: actionTypeKeys.SET_APPT_AUDIT,
      payload: id
    };
  };

  static getDeepLink = (id: string) => {
    return async (dispatch: Dispatch): Promise<boolean> => {
      const status: DeepLinkStatus = new DeepLinkStatus();
      status.isDeepLinkLoading = true;
      try {
        dispatch(MarketingLinkActions.setDeepLinkStatus(status));
        const link = await MarketingLinksApi.getDeepLink(id);
        if (link) {
          await dispatch(MarketingLinkActions.setDeepLink(link));

          status.isDeepLinkResolved = true;
          await dispatch(MarketingLinkActions.setDeepLinkStatus(status));

          dispatch(MarketingLinkActions.setAppointmentAudit(id));
        }
        return true;
      } catch (error) {
        return false;
      } finally {
        status.isDeepLinkLoading = false;
        dispatch(MarketingLinkActions.setDeepLinkStatus(status));
      }
    };
  };
}
